import axios, { AxiosResponse } from "axios";
import { ApiErrorHandler } from "../../../../errorHandler";
import { SignUpState } from "../../../shared/interfaces/components/signup.interface";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import apiClient from "../../shared/api/apiClient";

export const postSignup = (payload: SignUpState) => {
  // Object created with the keywords that BE/apigee expects.

  // The values are taken from the payload object and converted to the correct type.
  let products: Array<string> = [];
  if (payload.productsSelected !== null) {
    products = payload.productsSelected.map((item) => item.id.toString());
  }

  const object = {
    organizationName: payload.organizationName,
    organizationEmail: payload.organizationEmail,
    tier: "Basic",
    subscriptionDuration: "Monthly",
    numberEmployees: 35,
    products: ["4x21jZmnA0TNzZfA3i3l", "lemmughvsxbfl3vnsxo"],
    companyName: payload.companyName,
    VAT: payload.VAT,
    destinationCode: payload.destinationCode,
    pec: payload.pec,
    ...(payload.procurementAccountId ? { procurementAccountId: payload.procurementAccountId } : {}),
    ...(payload.userIdentity ? { userIdentity: payload.userIdentity } : {}),
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant`;

  return apiClient
    .post(URL, object)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const postSignupUser = (payload: SignUpState) => {
  // Object created with the keywords that BE/apigee expects.

  // The values are taken from the payload object and converted to the correct type.
  let products: Array<string> = [];
  if (payload.productsSelected !== null) {
    products = payload.productsSelected.map((item) => item.id.toString());
  }

  const displayName = `${payload.name} ${payload.surname}`;
  const object = {
    organizationName: displayName,
    organizationEmail: payload.email,
    tier: "Basic",
    subscriptionDuration: "Monthly",
    numberEmployees: 1,
    // products: ["lm8uu1x0fumx6wsse5", "4x21jZmnA0TNzZfA3i3l", "lenz0f1hf8qxuc1rqjc", "lemmughvsxbfl3vnsxo"],
    products: ["4x21jZmnA0TNzZfA3i3l", "lemmughvsxbfl3vnsxo"],
    companyName: `${payload.name} ${payload.surname}`,
    VAT: "",
    destinationCode: '00000',
    pec: "",
    userData: {
      name: payload.name,
      email: payload.email,
      surname: payload.surname,
      dateOfBirth: payload.dateOfBirth,
      city: payload.city,
      province: payload.province,
      fiscalCode: payload.fiscalCode,
      address: payload.address,
      phoneNumber: payload.phoneNumber,
    },
    isUser: payload.isUser,
    ...(payload.procurementAccountId ? { procurementAccountId: payload.procurementAccountId } : {}),
    ...(payload.userIdentity ? { userIdentity: payload.userIdentity } : {}),
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant`;

  return apiClient
    .post(URL, object)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
      throw e;
    });
};
